export type PossibleTypesResultData = {
  possibleTypes: {
    Node: [
      'Company',
      'Brand',
      'BrandTheme',
      'BrandThemeColor',
      'BrandThemeMessage',
      'Category',
      'MenuCategory',
      'MenuProduct',
      'Product',
      'TimeRule',
      'CalendarTimeRule',
      'ExceptionTimeRule',
      'WeekedayTimeRule',
      'ProductCompany',
      'MenuProductCompany',
      'Promotion',
      'Document',
      'CostumerDocument',
      'Customer',
      'AccountsUser',
      'User',
      'Card',
      'CardBrand',
      'Order',
      'Address',
      'OrderExtra',
      'OrderItem',
      'Payment',
      'Reward',
      'TemporaryUser',
      'CompanyCategory',
      'CompanyPhone',
      'Parameter',
      'PaymentParameter',
      'OrderTypeParameter',
      'AdditionalChargeParameter',
      'OrderFieldParameter',
      'OrderField',
      'CompanyGroup'
    ];
    Person: ['Customer', 'TemporaryUser'];
  };
};
const result: PossibleTypesResultData = {
  possibleTypes: {
    Node: [
      'Company',
      'Brand',
      'BrandTheme',
      'BrandThemeColor',
      'BrandThemeMessage',
      'Category',
      'MenuCategory',
      'MenuProduct',
      'Product',
      'TimeRule',
      'CalendarTimeRule',
      'ExceptionTimeRule',
      'WeekedayTimeRule',
      'ProductCompany',
      'MenuProductCompany',
      'Promotion',
      'Document',
      'CostumerDocument',
      'Customer',
      'AccountsUser',
      'User',
      'Card',
      'CardBrand',
      'Order',
      'Address',
      'OrderExtra',
      'OrderItem',
      'Payment',
      'Reward',
      'TemporaryUser',
      'CompanyCategory',
      'CompanyPhone',
      'Parameter',
      'PaymentParameter',
      'OrderTypeParameter',
      'AdditionalChargeParameter',
      'OrderFieldParameter',
      'OrderField',
      'CompanyGroup',
    ],
    Person: ['Customer', 'TemporaryUser'],
  },
};
export default result;
